import React, { useState } from 'react';
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice'; // Import nextTask action
import { Typography, TextareaAutosize, Button } from '@mui/material';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import {CustomConfirmationDialog, CustomWordCountDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed

const textareaStyle = {
    width: '100%',
    padding: '10px',
    fontSize: '19px',
    marginTop: '10px',
    fontFamily: 'Arial, sans-serif', // Apply a consistent font family
};

function RecallPositive({ nextTask }) {
    const [text, setText] = useState('');
    const wordCount = text.trim().length > 0 ? text.trim().split(/\s+/).length : 0;
    const minWordCount = 100; // Minimum word count required to proceed
    const [showDialog, setShowDialog] = useState(false);
    const [showWordCountDialog, setShowWordCountDialog] = useState(false);

    const handleChange = (event) => {
        setText(event.target.value);
    };


const handleNextClick = () => {
    if (wordCount === 0) {
        setShowDialog(true); // Show the confirmation dialog if word count is 0
    } else if (wordCount < minWordCount) {
        setShowWordCountDialog(true); // Show the alert dialog if word count is less than 100
    } else {
        nextTask({data: {recallTask: text, recallType: "positive"}})
    }
};


    return (
        <PageContainer>
        <div>
            <Typography gutterBottom>
            <strong>
                Take a moment to think of a SPECIFIC time when you received praise, respect, or esteem for something you did.
                </strong>
            </Typography>

            <div style={{ height: '10px' }}></div> 

            <Typography gutterBottom>
                Then, please write a description (at least 100 words) about how you were recognized and what you did to receive this recognition. You should try to recall where you were, who was with you, your thoughts and feelings about the situation, and/or how you responded to it.
            </Typography>
            
            <div style={{ height: '10px' }}></div> 

            <Typography gutterBottom>
                As you do this, please try to fully immerse yourself in the experience and to relive the emotions you felt as vividly as possible. It may help to visualize the events and to concentrate on those images.
            </Typography>
                   
            <div style={{ height: '10px' }}></div> 

            <Typography gutterBottom>
                <i>Your word count is</i>: {wordCount}
            </Typography>

            <div style={{ height: '10px' }}></div> 

            <TextareaAutosize
                minRows={4}
                maxRows={12}
                placeholder="Start typing here..."
                value={text}
                onChange={handleChange}
                style={textareaStyle}
            />

            <Button
                variant="contained"
                color="primary"
                sx={{ marginTop: '2em' }}
                onClick={handleNextClick} // Call handleNextClick when the "Next" button is clicked

            >
                Next
            </Button>

            <CustomConfirmationDialog
            open={showDialog}
            onClose={() => setShowDialog(false)}
            onConfirm={() => {
                setShowDialog(false);
                nextTask({ data: {recallTask: "n/a", recallType: "positive"} });
            }}
        />

        <CustomWordCountDialog
            open={showWordCountDialog}
            onClose={() => setShowWordCountDialog(false)}
        />

        
        </div>
        </PageContainer>

    );
}

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(RecallPositive);
